@if (!comparison) {
    <p class="empty">Choose a project to compare with to see what changes.</p>
} @else if (!rows.length) {
    <p class="empty">None of these change their {{fieldName}} between {{beforeName}} and {{afterName}}.</p>
} @else {
    <p class="pareto-headline">
        <b>{{rows.length}}</b> change: {{summary.up}} up, {{summary.down}} down.
        In all, it goes from {{value(summary.before, false)}} to {{value(summary.after, false)}}, {{totalChange()}}.
        @if (shown.length < rows.length) { The {{rows.length - shown.length}} smallest changes aren't shown. }
        @if (summary.unchanged) { {{summary.unchanged}} don't change. }
    </p>
    <div class="chart-legend" aria-label="What the dots mean">
        <span class="legend-item"><span class="dot before"></span>{{beforeName}}</span>
        <span class="legend-item"><span class="dot after" [style.background]="colour" [style.border-color]="colour"></span>{{afterName}}</span>
        <span class="legend-note">Largest change first{{log ? ", on a log scale as the values range widely" : ""}}. Click a name to select the node</span>
    </div>
    <div class="dumbbell" role="table" [attr.aria-label]="fieldName + ' before and after'">
        <div class="db-row db-scale" role="row" aria-hidden="true">
            <span></span>
            <span class="db-track">
                @for (t of ticks; track $index) { <span class="db-tick" [style.left]="at(t)">{{value(t)}}</span> }
            </span>
            <span></span>
        </div>
        @for (r of shown; track r.key) {
            <div class="db-row" role="row" [title]="tip(r)">
                <button type="button" class="row-name" role="rowheader" (click)="select(r)">{{r.name}}</button>
                <span class="db-track" role="cell">
                    @for (t of ticks; track $index) { <span class="db-grid" [style.left]="at(t)"></span> }
                    <span class="db-line" [style.left]="left(r)" [style.width]="width(r)" [style.background]="colour"></span>
                    <span class="dot before" [style.left]="at(r.before)"></span>
                    <span class="dot after" [style.left]="at(r.after)" [style.background]="colour" [style.border-color]="colour"></span>
                </span>
                <span class="db-change" role="cell" [class.up]="r.change > 0" [class.down]="r.change < 0">{{change(r)}}</span>
            </div>
        }
    </div>
}
